import { IMediaModel } from "../models";

export const getPlayable = (media: IMediaModel) => media.IsPlayable;
